import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store';
import * as types from '../store/mutation-types';
import Auth from '../auth/index';

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehaviour(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

export default router;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.commit(types.TOGGLE_MENU, false);
    return Auth.checkAuth(next);
  }
  return next();
});



// WEBPACK FOOTER //
// ./src/router/router.js